export default __webpack_public_path__ + "static/media/resume.95fa5b04.pdf";